module.exports = __webpack_public_path__ + "img/bar.c571d517.svg";